"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentCache = void 0;
var control_fonts_1 = require("./control-fonts");
var character_properties_cache_1 = require("./hashed-caches/character-properties-cache");
var color_model_info_cache_1 = require("./hashed-caches/color-model-info-cache");
var drawing_color_model_info_cache_1 = require("./hashed-caches/drawing-color-model-info-cache");
var font_info_cache_1 = require("./hashed-caches/font-info-cache");
var list_level_properties_cache_1 = require("./hashed-caches/list-level-properties-cache");
var masked_character_properties_cache_1 = require("./hashed-caches/masked-character-properties-cache");
var masked_paragraph_properties_cache_1 = require("./hashed-caches/masked-paragraph-properties-cache");
var paragraph_properties_cache_1 = require("./hashed-caches/paragraph-properties-cache");
var scene3d_properties_info_cache_1 = require("./hashed-caches/scene3d-properties-info-cache");
var scene3d_rotation_info_cache_1 = require("./hashed-caches/scene3d-rotation-info-cache");
var shading_info_cache_1 = require("./hashed-caches/shading-info-cache");
var table_cell_properties_cache_1 = require("./hashed-caches/table-cell-properties-cache");
var table_row_properties_cache_1 = require("./hashed-caches/table-row-properties-cache");
var images_1 = require("./images");
var DocumentCache = (function () {
    function DocumentCache() {
        this.imageCache = new images_1.ImageCache();
        this.controlFontsCache = new control_fonts_1.ControlFontsCache();
        this.fontInfoCache = new font_info_cache_1.FontInfoCache(null);
        this.mergedCharacterPropertiesCache = new character_properties_cache_1.CharacterPropertiesCache();
        this.mergedParagraphPropertiesCache = new paragraph_properties_cache_1.ParagraphPropertiesCache();
        this.maskedCharacterPropertiesCache = new masked_character_properties_cache_1.MaskedCharacterPropertiesCache();
        this.maskedParagraphPropertiesCache = new masked_paragraph_properties_cache_1.MaskedParagraphPropertiesCache();
        this.tableRowPropertiesCache = new table_row_properties_cache_1.TableRowPropertiesCache();
        this.tableCellPropertiesCache = new table_cell_properties_cache_1.TableCellPropertiesCache();
        this.listLevelPropertiesCache = new list_level_properties_cache_1.ListLevelPropertiesCache();
        this.shadingInfoCache = new shading_info_cache_1.ShadingInfoCache();
        this.colorModelInfoCache = new color_model_info_cache_1.ColorModelInfoCache();
        this.drawingColorModelInfoCache = new drawing_color_model_info_cache_1.DrawingColorModelInfoCache();
        this.scene3DPropertiesInfoCache = new scene3d_properties_info_cache_1.Scene3DPropertiesInfoCache();
        this.scene3DRotationInfoCache = new scene3d_rotation_info_cache_1.Scene3DRotationInfoCache();
    }
    DocumentCache.prototype.clearTemporaryCaches = function () {
        this.fontInfoCache.clearTemporaryCache();
        this.mergedCharacterPropertiesCache.clearTemporaryCache();
        this.mergedParagraphPropertiesCache.clearTemporaryCache();
        this.maskedCharacterPropertiesCache.clearTemporaryCache();
        this.maskedParagraphPropertiesCache.clearTemporaryCache();
        this.listLevelPropertiesCache.clearTemporaryCache();
        this.tableRowPropertiesCache.clearTemporaryCache();
        this.tableCellPropertiesCache.clearTemporaryCache();
        this.shadingInfoCache.clearTemporaryCache();
        this.colorModelInfoCache.clearTemporaryCache();
        this.drawingColorModelInfoCache.clearTemporaryCache();
        this.scene3DPropertiesInfoCache.clearTemporaryCache();
        this.scene3DRotationInfoCache.clearTemporaryCache();
    };
    DocumentCache.prototype.DEBUG_DISTRIBUTION_INFO = function () {
        var result = [];
        result.push("maskedCharacterPropertiesCache \t{elems:" + this.maskedCharacterPropertiesCache.count + ", maxLen:" + this.maskedCharacterPropertiesCache.DEBUG_MAX_CELL_LENGTH());
        result.push("maskedParagraphPropertiesCache \t{elems:" + this.maskedParagraphPropertiesCache.count + ", maxLen:" + this.maskedParagraphPropertiesCache.DEBUG_MAX_CELL_LENGTH());
        result.push("mergedCharacterPropertiesCache \t{elems:" + this.mergedCharacterPropertiesCache.count + ", maxLen:" + this.mergedCharacterPropertiesCache.DEBUG_MAX_CELL_LENGTH());
        result.push("mergedParagraphPropertiesCache \t{elems:" + this.mergedParagraphPropertiesCache.count + ", maxLen:" + this.mergedParagraphPropertiesCache.DEBUG_MAX_CELL_LENGTH());
        result.push("listLevelPropertiesCache \t{elems:" + this.listLevelPropertiesCache.count + ", maxLen:" + this.listLevelPropertiesCache.DEBUG_MAX_CELL_LENGTH());
        result.push("tableRowPropertiesCache \t{elems:" + this.tableRowPropertiesCache.count + ", maxLen:" + this.tableRowPropertiesCache.DEBUG_MAX_CELL_LENGTH());
        result.push("tableCellPropertiesCache \t{elems:" + this.tableCellPropertiesCache.count + ", maxLen:" + this.tableCellPropertiesCache.DEBUG_MAX_CELL_LENGTH());
        return result.join("\n");
    };
    DocumentCache.prototype.clone = function () {
        var cache = new DocumentCache();
        cache.fontInfoCache = this.fontInfoCache.clone();
        cache.controlFontsCache = this.controlFontsCache.clone();
        cache.mergedCharacterPropertiesCache = this.mergedCharacterPropertiesCache.clone();
        cache.mergedParagraphPropertiesCache = this.mergedParagraphPropertiesCache.clone();
        cache.maskedCharacterPropertiesCache = this.maskedCharacterPropertiesCache.clone();
        cache.maskedParagraphPropertiesCache = this.maskedParagraphPropertiesCache.clone();
        cache.tableRowPropertiesCache = this.tableRowPropertiesCache.clone();
        cache.tableCellPropertiesCache = this.tableCellPropertiesCache.clone();
        cache.listLevelPropertiesCache = this.listLevelPropertiesCache.clone();
        cache.imageCache = this.imageCache.clone();
        cache.shadingInfoCache = this.shadingInfoCache.clone();
        cache.colorModelInfoCache = this.colorModelInfoCache.clone();
        cache.drawingColorModelInfoCache = this.drawingColorModelInfoCache.clone();
        cache.scene3DPropertiesInfoCache = this.scene3DPropertiesInfoCache.clone();
        cache.scene3DRotationInfoCache = this.scene3DRotationInfoCache.clone();
        return cache;
    };
    return DocumentCache;
}());
exports.DocumentCache = DocumentCache;
